import React, { useState } from "react";
import { AbstructLang } from "../General/GeneralComponent/AbstructLang";
import SelectWithSearch from "../General/GeneralComponent/SelectWithSearch";
import { useSelectorCustom } from "../General/GeneralComponent/useSelectorCustom";
import { FunctionsLoading } from "../Main/Statistics/FunctionsLoading";
import { Trans } from "./VariableAssign";
import { base_url, notifyError, notifysuccess } from "../../Components/General/Notification";
import axios from "axios";

function Transferring({ langmiamed }) {
  const { translate } = AbstructLang();
  const { state, handleChangeAssign, resetAssignments } = Trans(); // Added resetAssignments function
  const { medicalRep, loadingmedicalRep } = useSelectorCustom();
  const { LoadMedicalRepCustom } = FunctionsLoading();
  const [load, setLoad] = useState(false);

  const send = async (e) => {
    e.preventDefault();
    let token = localStorage.getItem("tokenMiamed");
    const { from_medical_rep_id, to_medical_rep_id } = state;
    setLoad(true);
    axios.post(
            `${base_url}api/medical-rep/migrate-assignments-target-group`,
            { from_medical_rep_id, to_medical_rep_id },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
    .then((res) => {
        if (res.data.status == "Success") {
          notifysuccess(res.data.message);
          setLoad(false)
          // window.location.reload();
         }
      })
      .catch((err) => {
        notifyError(err.response.data.message);
      });

  };

  return (
    <>
      <div className="div_assign">
        <h5 className={langmiamed === "ar" ? "textRight" : ""}>
          {translate("Transfer Assignments")}
        </h5>
      </div>
      <div className="all_div_select">
        <div>
          <p className={`seespec ${langmiamed === "ar" ? "textRight" : ""}`}>
            {translate("Choose the representatives for transferring assignments")}
          </p>
        </div>
        <div >
          {/* From Medical Representative */}
          <SelectWithSearch
            load={loadingmedicalRep}
            typeCss={true}
            array={medicalRep}
            setId={(value) => handleChangeAssign("from_medical_rep_id", value)}
            funb={LoadMedicalRepCustom}
          />
        </div>
        <div>
          <p className={`seespec ${langmiamed === "ar" ? "textRight" : ""}`}>
            {translate("Choose the representative to whom you want to assign the data")}
          </p>
        </div>
        <div>
          {/* To Medical Representative */}
          <SelectWithSearch
            load={loadingmedicalRep}
            typeCss={true}
            array={medicalRep}
            setId={(value) => handleChangeAssign("to_medical_rep_id", value)}
            funb={LoadMedicalRepCustom}
          />
        </div>
      </div>
      {/* Submit Button */}
      <div
        className="confirm-button-container"
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        <button onClick={send} disabled={load} className="btn btn-primary">
          {load ? translate("Loading...") : translate("Confirm Transfer")}
        </button>
      </div>
    </>
  );
}

export default Transferring;
